import { Injectable } from '@angular/core';

import { ProductInterface } from '../data';
import { MemoryMapCacheRepository } from './memory-map-cache.repository';

@Injectable()
export class ProductCacheRepository extends MemoryMapCacheRepository<ProductInterface[]> {
    getKey(mine = false): string {
        return 'ProductCacheRepository' + (mine ? 'Mine' : '');
    }
}
